// causeTypesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;

// Create axios instance
const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Thunk for fetching cause types
export const fetchCauseTypes = createAsyncThunk(
  'causeTypes/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/CauseTypes/', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data.results;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch cause types'
      );
    }
  }
);

// Thunk for creating cause type
export const createCauseType = createAsyncThunk(
  'causeTypes/create',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosInstance.post('/CauseTypes/', data,  {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      // Refresh the list after successful creation
      dispatch(fetchCauseTypes());
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to create cause type'
      );
    }
  }
);

const initialState = {
  items: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  createStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  createError: null,
  totalCount: 0,
};

const causeTypesSlice = createSlice({
  name: 'causeTypes',
  initialState,
  reducers: {
    resetCreateStatus: (state) => {
      state.createStatus = 'idle';
      state.createError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch cause types cases
      .addCase(fetchCauseTypes.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCauseTypes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
        state.totalCount = action.payload.length;
      })
      .addCase(fetchCauseTypes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Create cause type cases
      .addCase(createCauseType.pending, (state) => {
        state.createStatus = 'loading';
        state.createError = null;
      })
      .addCase(createCauseType.fulfilled, (state) => {
        state.createStatus = 'succeeded';
      })
      .addCase(createCauseType.rejected, (state, action) => {
        state.createStatus = 'failed';
        state.createError = action.payload;
      });
  },
});

// Selectors
export const selectAllCauseTypes = (state) => state.causeTypes.items;
export const selectCauseTypesStatus = (state) => state.causeTypes.status;
export const selectCreateStatus = (state) => state.causeTypes.createStatus;
export const selectError = (state) => state.causeTypes.error;
export const selectCreateError = (state) => state.causeTypes.createError;
export const selectTotalCount = (state) => state.causeTypes.totalCount;

export const { resetCreateStatus } = causeTypesSlice.actions;
export default causeTypesSlice.reducer;